// @core/api/endpoints/team/list_team_permissions.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTeamPermissionsResponse,
} from '../../../types/team';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/team';

/**
 * List role permissions
 * Returns all permissions assigned to a specific role, showing what actions role holders can perform.
 */
export async function ListTeamPermissions(
  team_id: string,
  role_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTeamPermissionsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/roles/:role_id/permissions`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':role_id', encodeURIComponent(role_id));
  const requestOptions = options;
  return client.get<ListTeamPermissionsResponse>(requestPath, { ...requestOptions, params });
}
